import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface LightingDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const LightingDescription: React.FC<LightingDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [lighting, set_lighting] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Lighting']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Lighting': [v, b.values?.['Interior']?.['Lighting']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={lighting}
                />
            ) : (
                <TextBox
                    value={lighting}
                    onChange={(value) => set_lighting(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
